// const BASE_URL = 'http://3.21.244.222:4000/api';
// const BASE_URL = 'http://3.148.254.56:4000/api'; // new assigned IP
const BASE_URL = 'https://api.olaitools.com/api';
// const BASE_URL = 'http://localhost:4000/api';

export const fetchLtiSessionInfo = async () => {
    try {
        const response = await fetch(`${BASE_URL}/dashboard/lti-session-info`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch LTI session info');
        }
        
        const data = await response.json();
        console.log('Front - API - overviewApi - LTI session info data:', data);
        return data;
    } catch (error) {
        console.error("Error fetching LTI session info:", error);
        throw error;
    }
}


export const fetchDemoSubmissionCount = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-submission-count${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo submission count');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching demo submission count:", error);
        throw error;
    }
};

export const fetchDemoQuestionAverage = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-question-average${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo question average');
        }
        const data = await response.json();
        console.log('Front - API - overviewApi - Demo question average:', data);
        return data;
    } catch (error) {
        console.error("Error fetching demo question average:", error);
        throw error;
    }
};

export const fetchAllDemoSubmissionDates = async () => {
    try {
        const response = await fetch(`${BASE_URL}/dashboard/all-demo-submission-dates`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch demo submission dates');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Demo submission dates:', data);
        return data;
    } catch (error) {
        console.error("Error fetching demo submission dates:", error);
        throw error;
    }
};

export const fetchDemoClickTimeRange = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/click-timerange${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo click time range');
        }
        const data = await response.json();
        console.log("Demo click time range", data);
        return data;
    } catch (error) {
        console.error("Error fetching demo click time range:", error);
        throw error;
    }
}